import { render, staticRenderFns } from "./platformHouseholdList.vue?vue&type=template&id=75e01183&scoped=true"
import script from "./platformHouseholdList.vue?vue&type=script&lang=js"
export * from "./platformHouseholdList.vue?vue&type=script&lang=js"
import style0 from "./platformHouseholdList.vue?vue&type=style&index=0&id=75e01183&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e01183",
  null
  
)

export default component.exports